























import { Component, Prop, Vue } from 'vue-property-decorator';
import SimpleCompanySearch from "@/components/new_style_components/SimpleCompanySearch.vue";
import CompanyDTO from "@/dto/company/CompanyDTO";
import { processError } from "@/utils/ComponentUtils";
import Application from "@/state/Application";
import PRILService from "@/services/request/PRILService";

@Component({
  components: {
    SimpleCompanySearch
  }
})
export default class ChangeCompanyModal extends Vue {
  private selectedCompany: CompanyDTO | null = null;
  private confirmationStep = false;

  @Prop()
  private prilId!: number;

  @Prop()
  private onSuccess!: () => void;

  private closeModal(): void {
    this.resetModal();
    this.$modal.hideAll();
  }

  private resetModal(): void {
    this.selectedCompany = null;
    this.confirmationStep = false;
  }

  private confirmChangeCompany(): void {
    // If we don't have a selected company yet, do nothing
    if (!this.selectedCompany) {
      return;
    }

    // If we're not in confirmation step yet, show confirmation
    if (!this.confirmationStep) {
      this.confirmationStep = true;
      return;
    }

    // If we're in confirmation step and have a selected company, proceed with the API call
    Application.startLoading();
    PRILService.changeCompany(this.prilId, this.selectedCompany.id!).then(
      resp => {
        Application.stopLoading();
        this.$modal.hideAll();
        this.$bvToast.toast('Company changed successfully', {
          title: 'Success',
          variant: 'success',
          solid: true
        });
        this.onSuccess();
      },
      error => processError(error, this)
    );
  }
}
